import plansPage from './plans-page';

export default [plansPage];
